import initialState from './initialState'

const SET_EMPLOYEE = (state, employee) => {
    state.employee = employee
}
const SET_VALID_EMPLOYEE = (state, boolean) => {
    state.validEmployee = boolean
}
/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

export default { RESET_STATE, SET_EMPLOYEE, SET_VALID_EMPLOYEE }
